/* eslint-disable camelcase */
import { SearchService } from '../lib';
import { shouldUseTypeBasedEntityApi } from 'utils/entityIdentifier';

class EntityRecordSearchService extends SearchService {
  search = (ids = {}, params = {}) => {
    const { context, ...requestParams } = params;
    if (shouldUseTypeBasedEntityApi()) {
      const { schema_id, ...rest } = requestParams;
      return this.dispatch('ENTITY_RECORDS_SEARCH', { id: schema_id, ...ids }, rest);
    }
    return this.dispatch('ENTITY_RECORDS_SEARCH', ids, requestParams);
  };
}

export const entityRecordSearchService = new EntityRecordSearchService();
